module.exports = __webpack_public_path__ + "img/expovina-primavera_03(1).1ed02c4e.jpg";